
/**
 * Utility functions for handling attachment order calculations
 */

interface AttachmentWithOrder {
  attachment_order?: number | null;
}

/**
 * Safely calculates the next attachment order from existing attachments
 */
export const calculateNextAttachmentOrder = (existingAttachments: unknown[]): number => {
  if (!existingAttachments || existingAttachments.length === 0) {
    return 1;
  }

  const firstAttachment = existingAttachments[0] as AttachmentWithOrder;
  if (firstAttachment && typeof firstAttachment.attachment_order === 'number') {
    return firstAttachment.attachment_order + 1;
  }

  return 1;
};
